export function mergeCachedRecord(existing, incoming, nestedKeys = []) {
  if (!existing) return incoming;

  const merged = { ...existing, ...incoming };
  for (const key of nestedKeys) {
    const existingValue = existing[key];
    const incomingValue = incoming[key];
    if (isPlainObject(existingValue) && isPlainObject(incomingValue)) {
      merged[key] = { ...existingValue, ...incomingValue };
    }
  }
  return merged;
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}
